var SchoolOrgList = require("components/appdev/wizards/SchoolOrgList");

class SchoolOrgListPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { loadSchools: false }
	}

	render() {
		return (
			<div className="SchoolOrgListPage container">

				<div className="headerSection">
					<header className="pageHeader">
						<h1>School Orgs</h1>
					</header>
				</div>

				<SchoolOrgList />
				
			</div>
		)
	}
};

SchoolOrgListPage.propTypes = PageStrictPropTypes({
});

module.exports = SchoolOrgListPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/SchoolOrgListPage.js